import clsx from 'clsx'

interface Props {
    status: string
    className?: string
}

const statusColor: Record<string, string> = {
    've výrobě': 'bg-red-600',
    'u dodavatele': 'bg-red-600',
    blokováno: 'bg-amber-600',
    expedováno: 'bg-green-700',
    nová: 'bg-primary',
}

export default function OrderItemState({ status, className }: Props) {
    return (
        <span
            className={clsx(
                'badge text-white whitespace-nowrap',
                statusColor[status?.toLowerCase()] || 'bg-gray-400',
                className
            )}
        >
            {status}
        </span>
    )
}
